import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { ShowServiceModalComponent } from '@core/show-service-modal/show-service-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgOtpInputModule } from 'ng-otp-input';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { CdkCustomMdlModule } from '@core/customCDK/cdkCustomMdl/cdk-custom-mdl.module';
import { ErrorComponent } from '@core/form-validation/error-component/error-component';
import { FormControlValidationDirective } from '@core/form-validation/directives/form-control-validation.directive';
import { FormGroupValidationDirective } from '@core/form-validation/directives/form-group-validation.directive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PytModule } from '@core/custome-modal/pytCustTbl/pyt-module';


@NgModule({
  declarations: [
    ShowServiceModalComponent,
    ErrorComponent,
    FormControlValidationDirective,
    FormGroupValidationDirective

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    DragDropModule,
    CdkCustomMdlModule,
    NgOtpInputModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    // NgxUiLoaderModule,
    // DynamicFormBuilderModule,
    OverlayModule,
    // NgxLoadingXModule.forRoot(ngxLoadingXConfig),
    CollapseModule.forRoot(),
    NgApexchartsModule,
    PytModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    BsDatepickerModule,
    ShowServiceModalComponent,
    // DynamicFormBuilderModule,
    OverlayModule,
    CdkCustomMdlModule,
    // NgxLoadingXModule,
    NgOtpInputModule,
    CollapseModule,
    ErrorComponent,
    FormControlValidationDirective,
    FormGroupValidationDirective,
    NgApexchartsModule,
    PytModule
  ],
})
export class SharedModule { }
